import { safeClone, ViewStream } from "spyne";
import { CodeContainerTraits } from "traits/code-container-traits";
import { CodePlaygroundMenuList } from "components/code-playground/code-playground-menu-list";

export class CodePlaygroundMenu extends ViewStream {
  constructor(props = {}) {
    props.class = "code-playground-menu";
    props.traits = CodeContainerTraits;
    // const {type} = props.payload.codeGenData;

    const reduceStates = (acc, obj) => {
      const newObj = safeClone(obj);
      newObj["type"] = type;
      acc.push(newObj);

      return acc;
    };

    const reduceToExamples = (acc, o) => {
      const { type, states } = o;

      states.reduce(reduceStates, acc);
      return acc;
    };

    // const {types, examples} = props.payload.codeGenData;
    // const examples = types.reduce(reduceToExamples, []);
    //props.data = safeClone(props.payload.codeGenData.types[0]);

    // const examples = props.data.reduce(reduceStates, []);
    //console.log(props.data," types is DATA ",props.payload.codeGenData.types[0].states);
    //console.log("MENU DATA IS ",props.data, props.codeBlockId);
    // props.template = require('./template/code-playground-menu.tmpl.html');

    super(props);
  }

  addActionListeners() {
    const codeBlockIdPayloadFilter =
      this.codeContainer$GetCodeBlockIdPayloadFilter();

    return [
      [
        "CHANNEL_CODE_CONTAINER_UPDATE_EVENT",
        "onChannelCodeUpdate",
        codeBlockIdPayloadFilter,
      ],
      ["CHANNEL_CODE_CONTAINER_ROUTE_EVENT", "onCodeContainerRouteEvent"],
    ];
  }

  onCodeContainerRouteEvent(e) {
    const { stage, classMethod } = e.payload;
    const btnSelector = () =>
      `[data-class-method='${classMethod}'][data-stage='${stage}']`;

    this.props.initialClassMethod$ = this.props.el$(btnSelector());

    //console.log('route event',this.props.codeBlockId, e.payload);
    this.sendInitialEvent();
  }

  onChannelCodeUpdate(e) {
    const { payload } = e;
    const { num, prevNum, sectionNum } = payload;
    const sel = `.code-playground-btn-${num}-${sectionNum}`;

    const forEachMenuBtn = (btnEl) => {
      btnEl.dataset["prevNum"] = num;
     //console.log"btnEl is ", btnEl.dataset, btnEl);
    };

    this.props.btns$.forEach(forEachMenuBtn);
    this.props.btns$.setActiveItem("active", sel);

   //console.log"MENU PAYLOAD ",{payload, sel,num,prevNum}, this.props.codeBlockId)
  }

  sendInitialEvent() {
    const { codeBlockDataSection } = this.props;
    const firstBtnEl = this.props.btns$.arr[0];

    const selectedBtnEl = this.props?.initialClassMethod$?.exists
      ? this.props.initialClassMethod$.el
      : firstBtnEl;
    const initialLoad = true;
    const { codeBlockId, methodName, codeBlockStateName, num, prevNum } =
      selectedBtnEl.dataset;

    //console.log("INITIAL ",this.props?.initialClassMethod$?.exists, selectedBtnEl)

    const action = "CHANNEL_CODE_CONTAINER_REQUEST_UPDATE_EVENT";
    const channelName = "CHANNEL_CODE_CONTAINER";
    this.sendInfoToChannel(
      channelName,
      {
        codeBlockId,
        methodName,
        initialLoad,
        codeBlockDataSection,
        codeBlockStateName,
        num,
        prevNum,
      },
      action,
    );
    /**
     * TODO: HAVE THIS LISTEN TO ROUTE CHANGE WITH SECTION FILTER AND FIND SEND METHOD TO CHANNEL_CODE_CONTAINER
     *
     * */
  }

  broadcastEvents() {
    // return nexted array(s)
    return [["button", "click"]];
  }

  addMenuSections() {
    const { codeBlockDataSection } = this.props;
    const template = require("./template/code-playground-menu.tmpl.html");
    const addMenuSection = (state, i) => {
      // const ulEl = new ViewStream({data, template})
      //this.props.el.appendChild(ulEl.render());
      //this.appendView(ulEl);

      this.appendView(
        new CodePlaygroundMenuList({ data: { state }, codeBlockDataSection }),
      );
    };
    //console.log("data is ",this.props.data.states.__cms__isProxy, this.props.data);

    this.props.data.states.forEach(addMenuSection);
  }

  onRendered() {
    this.addMenuSections();
    this.props.btns$ = this.props.el$("button");
    this.addChannel("CHANNEL_CODE_CONTAINER");

    //console.log("menu code container ",this.props);
    this.sendInitialEvent();
   //console.log'onRendered event',this.props.codeBlockId);
  }
}
